export default function SignupFooter() {
  return (
    <>
      <p className="mb-5 text-center">For inquiries about Briefpoint's Enterprise Packages, please contact <a href="mailto:support@briefpoint.ai?subject=Pricing">support@briefpoint.ai</a> to discuss your firm's specific needs.</p>
    </>
  );
}